import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CoreUIContextMenuItem } from '../../icons/core-ui-context-menu/core-ui-context-menu.component';

export type CoreUIMediaCardStatus = 'active' | 'inactive';

@Component({
  selector: 'core-ui-media-card',
  standalone: false,
  templateUrl: './media-card.component.html',
  styleUrls: ['./media-card.component.scss'],
})
export class CoreUIMediaCardComponent implements OnChanges {
  @Input() loading = false;
  @Input() imageUrl: string | null = null;
  @Input() imageAlt = '';
  @Input() title = '';
  @Input() metadata = '';
  @Input() statusLabel = '';
  @Input() status: CoreUIMediaCardStatus = 'inactive';
  @Input() actions: readonly CoreUIContextMenuItem[] = [];
  @Input() ariaLabel = '';
  @Input() actionsAriaLabel = 'Acciones';
  @Input() actionsMenuWidth?: string;

  @Output() selected = new EventEmitter<void>();
  @Output() actionSelected = new EventEmitter<string>();

  imageLoading = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['imageUrl']) this.imageLoading = Boolean(this.imageUrl);
  }

  onImageSettled(): void {
    this.imageLoading = false;
  }
}
